import styled from '@emotion/styled/macro';

export const Wrapper = styled.section`
    width: 100vw;
    height: 100vh;
    overflow: auto;
    box-sizing: border-box;
`;
